<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      row-id="inspectionCode"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
        trigger: 'row'
      }"
      @cell-click="onCellClick"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="statusTagType(row.status)"
          :color="row.status == 'R' ? 'white' : ''"
        >
          {{ row.v_status }}
        </el-tag>
      </template>
      <template v-slot:displayAuditResultType="{ row }">
        <el-tag
          v-if="row.auditResultType"
          size="mini"
          :type="auditResultTypeTagType(row.auditResultType)"
          :color="row.auditResultType == 'R' ? 'white' : ''"
        >
          {{ row.auditResultTypeText ? row.auditResultTypeText : '--' }}
        </el-tag>
      </template>
      <template v-slot:purchaseMaterial="{ row }">
        <div>
          <span>
            {{ $l('table_label_materialNo') || '编码' }}：{{
              row.materialNo
            }}</span
          >
          <br />
          <span>
            {{ $l('table_label_materialName') || '名称' }}：{{
              row.materialName
            }}</span
          >
        </div>
      </template>
      <template v-slot:reporterNames="{ row }">
        <div v-if="row.reporterNames">
          <div
            v-for="(item, index) in row.reporterNames.split('、')"
            :key="index"
          >
            <span style="text-align: left;">{{ item }}</span>
          </div>
        </div>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createTime }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyTime }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <ButtonGroup
          :options="opts"
          :row="row"
          :viewText="$l('INDEX.btn_tips_view_V2') || '查看详情'"
          @command="optCommand"
        />
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import ButtonGroup from './buttonGroup.vue'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: {
    ButtonGroup
  },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: tableColumns(this)
    }
  },
  computed: {
    opts() {
      return tableOpts(this)
    }
  },
  methods: {
    statusTagType(type) {
      return {
        A: 'success',
        N: 'info',
        D: 'danger',
        Q: 'warning',
        C: '',
        R: 'danger'
      }[type]
    },
    auditResultTypeTagType(type) {
      return {
        P: 'success',
        R: 'danger',
        C: 'warning'
      }[type]
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'quality-iqcInspectionReport-detail',
        params: { ...params, pageType },
        query
      })
    },
    onCheckboxChange({ records, reserves }) {
      this.$emit('checkboxChange', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['col-opt']
      if (!filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)
      const data = $table.getCheckboxRecords(true) || []
      const reserves = $table.getCheckboxReserveRecords(true) || []
      this.$emit('checkboxChange', data.concat(reserves))
    },
    optCommand({ opt, data }) {
      const { menuType } = opt
      switch (menuType) {
        case 'detail':
          this.openEditPage({
            pageType: 'detail',
            params: { code: data.inspectionCode },
            query: { inspectionNo: data.inspectionNo }
          })
          break
        case 'print':
          this.$emit('printData', data)
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
